import { GutXAxisBody } from '@repo/ui';
import { useEffect } from 'react';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import useOrgans from 'services/organs/useOrgans';
import styles from './BodyContainer.module.css';
import { useOrganSelect } from './hooks';

export default function BodyContainer() {
  const { currentKit, currentKitId, currentTinyAccount } =
    useCurrentKitAndTinyAccount();
  const { trackEventOnce } = useAnalytics();
  const handleOrganSelect = useOrganSelect();

  const { organs } = useOrgans(currentKit?.id);

  useEffect(() => {
    if (!currentKitId) return;
    trackEventOnce('Conditions Card Viewed', currentKitId);
  }, [currentKitId, trackEventOnce]);

  return (
    <div className={styles.container}>
      <GutXAxisBody
        age={currentKit?.age_at_sampling ?? 0}
        pregnant={!!currentKit?.pregnant}
        organs={organs}
        sex={currentTinyAccount?.sex ?? 'M'}
        onOrganSelect={handleOrganSelect}
      />
    </div>
  );
}
